import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PwaInstallService {
    private deferredPrompt: any;
    private isInstallable$ = new BehaviorSubject<boolean>(false);

    constructor() {
        this.initInstallPrompt();
    }

    private initInstallPrompt(): void {
        window.addEventListener('beforeinstallprompt', (event: Event) => {
            // Prevent the mini-infobar from appearing on mobile
            event.preventDefault();
            // Stash the event for later use
            this.deferredPrompt = event;
            // Update the install button UI and availability
            this.isInstallable$.next(true);
        });

        window.addEventListener('appinstalled', () => {
            console.log('PWA installed successfully');
            this.isInstallable$.next(false);
        });
    }

    /**
     * Trigger the install prompt
     */
    async install(): Promise<void> {
        if (!this.deferredPrompt) {
            return;
        }

        // Show the install prompt
        this.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await this.deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        // Regardless of user choice, we can't use the prompt again
        this.deferredPrompt = null;
        this.isInstallable$.next(false);
    }

    /**
     * Observable to check if PWA is installable
     */
    getInstallableState(): Observable<boolean> {
        return this.isInstallable$.asObservable();
    }

    /**
     * Check if PWA is installed
     */
    isInstalledAsApp(): boolean {
        return window.matchMedia('(display-mode: standalone)').matches ||
            (window.navigator as any).standalone === true;
    }
}
